import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Dialog } from "@material-ui/core";
import Assignment from "@material-ui/icons/Assignment";
import { Grid } from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { useFeedback } from "./FeedbackContext";
import { feedbackModalStyles } from "./feedbackStyles";
import FeedbackTopicList from "./FeedbackTopicList";
import FeedbackTopicDetail from "./FeedbackTopicDetail";
import ModalHeader from "../ModalHeader";

const useStyles = makeStyles(feedbackModalStyles);

export default function FeedbackModal({ clientColor }) {
  const classes = useStyles();
  const {
    modalOpen,
    setModalOpen,
    selectedTopic,
    loading,
    loadingDetail,
    activeTopicsCount,
  } = useFeedback();
  const { t } = useTranslation();

  return (
    <Dialog
      classes={{
        root: classes.modalRoot,
        paper: classes.modal,
      }}
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      maxWidth={false}
      fullWidth
    >
      <ModalHeader
        title={t("feedback.title")}
        pills={
          activeTopicsCount > 0
            ? [
                {
                  key: "active",
                  label: t("feedback.active_count", {
                    count: activeTopicsCount,
                  }),
                },
              ]
            : []
        }
        onClose={() => setModalOpen(false)}
        closeLabel={t("modeling_inputs_v2.drawer.close", "Fechar")}
        clientColor={clientColor}
      />

      {loading ? (
        <div className={classes.loadingContainer}>
          <span className={classes.loadingLabel}>
            {t("feedback.loading_topics")}
          </span>
          <Grid width={40} height={40} color={clientColor} />
        </div>
      ) : (
        <div className={classes.splitContainer}>
          <div className={classes.leftPanel}>
            <FeedbackTopicList clientColor={clientColor} />
          </div>

          <div className={classes.rightPanel}>
            {loadingDetail ? (
              <div className={classes.loadingContainer}>
                <Grid width={40} height={40} color={clientColor} />
              </div>
            ) : selectedTopic ? (
              <FeedbackTopicDetail clientColor={clientColor} />
            ) : (
              <div className={classes.emptyState}>
                <Assignment className={classes.emptyIcon} />
                <div className={classes.emptyText}>
                  {t("feedback.select_topic_hint")}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Dialog>
  );
}

FeedbackModal.propTypes = {
  clientColor: PropTypes.string,
};
